import axios from 'axios'
import { CADASTRAR_ROTA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function cadastrarRota (empresa) {
  const url = `${URL}/rota/cadastrar`;
  return dispatch => axios.post(url, empresa, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CADASTRAR_ROTA,
        payload: response
      })
  );
}
